module.exports = __webpack_public_path__ + "static/MapMedium-5a4bdac4c898640aaa0b6a3739ff675c.svg";